import React from "react";
import "./Css/ExamView.css";
import { useNavigate } from "react-router-dom";

const students = [
  {
    id: 1,
    date: "७ फेब्रुवारी , २०२५",
    book: "६५०",
    roll: "₹ ४,१२,०००",
    per: "१२%",
    total: "₹ ४९,४४०",
    status: "पावती पहा",
  },
  {
    id: 2,
    date: "५ फेब्रुवारी , २०२५",
    book: "७८०",
    roll: "₹ ३,५१,०००",
    per: "१२%",
    total: "₹ ४२,१२०",
    status: "पावती पहा",
  },
  {
    id: 3,
    date: "५ जानेवारी, २०२५",
    book: "९२०",
    roll: "₹ २,९४,५००",
    per: "१२%",
    total: "₹ ३५,३४०",
    status: "पावती पहा",
  },
];

const CumissionView = () => {
    const navigate = useNavigate();

  return (
    <div className="exam-container">
      <div className="page-header">
        <h3    style={{ cursor: "pointer" }}
        onClick={() => navigate(-1)}>
         कमिशन व्यवस्थापन &gt;&gt; <span>कमिशन तपशील</span>
        </h3>
      </div>
      {/* Form Section */}
      <div className="exam-form">
        <div className="form-group">
          <label>संस्थेचे नाव</label>
          <input value="ज्ञानदीप इंग्लिश स्कूल" readOnly />
        </div>

        <div className="form-group">
          <label>एकूण विक्री </label>
          <input value="११" readOnly />
        </div>

        <div className="form-group">
          <label>एकूण कमिशन</label>
          <input value="₹ ५५  " readOnly />
        </div>

        <div className="form-group">
          <label>बाकी रक्कम</label>
          <input value="₹ ० " readOnly />
        </div>

        <div className="form-group">
          <label>शेवटच्या व्यवहाराची तारीख</label>
          <input value="७ फेब्रुवारी , २०२५" readOnly />
        </div>

        <div className="form-group">
          <label>कमिशन टक्केवारी</label>
          <input value="५%" readOnly />
        </div>
      </div>

      {/* Table */}
      <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>क्र.</th>
              <th>तारीख</th>
              <th>विक्री झालेल्या पुस्तकांची संख्या</th>
              <th>एकूण विक्री रक्कम</th>
              <th>कमिशन (%)</th>
              <th>कमिशन रक्कम</th>
              <th>क्रिया</th>
            </tr>
          </thead>
          <tbody>
            {students.map((s, index) => (
              <tr key={s.id}>
                <td>{index + 1}</td>
                <td>{s.date}</td>
                <td>{s.book}</td>
                <td>{s.roll}</td>
                <td>{s.per}</td>
                <td>{s.total}</td>
               <td
      className="status-cell"
      style={{ cursor: "pointer", color: "#1a73e8" }}
      onClick={() => navigate("/dashboard/invoice")}
    >
      {s.status}
    </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CumissionView;
